/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkstepopen3Inputs */

const en_profilelinkstepopen3 = /** @type {(inputs: Profilelinkstepopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Pulsify on your phone.`)
};

const de_profilelinkstepopen3 = /** @type {(inputs: Profilelinkstepopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne Pulsify auf deinem Handy.`)
};

/**
* | output |
* | --- |
* | "Open Pulsify on your phone." |
*
* @param {Profilelinkstepopen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkstepopen3 = /** @type {((inputs?: Profilelinkstepopen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkstepopen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkstepopen3(inputs)
	return de_profilelinkstepopen3(inputs)
});
export { profilelinkstepopen3 as "profileLinkStepOpen" }